<template>
  <van-config-provider :theme-vars="themeVars">
  <div class="van-hairline--surround">
       <van-cell-group inset border="false">
         <h3 style="padding-top: 1em;">镖计划简介</h3>
         <p class="textIndentation">深圳镖计划科技信息有限公司，一家于2023年在广东省深圳市崛起的科技推广和应用服务业为主的企业，我们以智慧、秩序、繁荣为导向，致力于为跨境卖家的每一场商业战争提供坚实的支持与法律保障。 </p>

         <p class="textIndentation">我们的理念，是向强者学习，以此推动自身不断进步，同时也为中国创新献计献策，保驾护航。我们拥有专业的中美知识产权服务团队，十年如一日在知识产权领域深耕，不断的学习，不断的进步，积攒了丰富的实战经验，能精准处理中国跨境卖家在美国的知识产权诉讼和专利申请问题，为您的产品提供全方位的知识产权保护。</p>

         <p class="textIndentation">知识产权不仅是保护市场、开拓市场、避免内卷的武器，更是我们获得行业地位与话语权的重要工具。我们视知识产权为长期的战略投资，而非快餐化兼补助的工具。从千禧年的互联网时代到如今变革时代的万物智能，我们外律人一直秉持探索的精神，从未停止前进的脚步。</p>

         <p class="textIndentation">深圳镖计划科技信息有限公司，将与您并肩作战，主沉浮于您的每一场商业战争。无论面对何种挑战，我们都将以专业的知识和丰富的经验，为您提供最优质的服务，成为您最值得信赖的伙伴。让我们携手共进，共创美好的未来。
         </p>
       </van-cell-group>
        <br/>
       <p class="match">
          <van-notice-bar color="#EA6853" wrapable :scrollable="false">
            <strong>如果您有任何问题，可以在【镖计划】公众号底部留言，我们会及时回复。</strong>
         </van-notice-bar>
          </p>
   </div>
 </van-config-provider>
</template>
<script>
import { reactive, onMounted } from 'vue';
export default {
 setup() {

   const themeVars = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const kpian = reactive({
     cellGroupBackground: '#AAAAAA',
   });
   const kpianawait = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const themeVars2 = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const ulog = reactive({
      UserLog: {
        path: '',
      }
    })
   onMounted(() => {
  
        console.log("当前页面路径=="+ulog.UserLog.path) 
   })
   return {
     //fid,
     themeVars,
     kpian,
     kpianawait,
     themeVars2,
   }
 }
}
</script>
<style scoped>
#app {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 -webkit-font-smoothing: antialiased;
 -moz-osx-font-smoothing: grayscale;
 text-align: center;
 height: 100%;
 color: #2c3e50;
}

.textIndentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
 line-height:30px;
}

.text2Indentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1px;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}

.match {
 text-align: left;
 text-indent: 1em;
 font-size: 14px;
}

.text3Indentation {
 text-align: left;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}
</style>
